export const productionConfig = {
    appEnv:  "production",
    brand: "vodacom",
    scorePredictorServiceUrl: "https://vodacompredictor.com/score-predictor-service",
    infinityApiUrl: "https://vodacomfantasy.com/api",
    entryPortalHost: "https://vodacomfantasy.com",
    fantasyHost: "https://fantasysoccer.vodacomfantasy.com",
    upstreamIntegrationHost: "https://utils.vodacomfantasy.com/upstream",
};

export const stagingConfig = {
    appEnv:  "staging",
    brand: "vodacom",
    scorePredictorServiceUrl: "https://staging.vodacompredictor.com/score-predictor-service",
    infinityApiUrl: "https://vodacomfantasy.com/api",
    entryPortalHost: "https://staging.vodacomfantasy.com",
    fantasyHost: "https://staging.fantasysoccer.vodacomfantasy.com",
    upstreamIntegrationHost: "https://staging.utils.vodacomfantasy.com/upstream",
};


const environment = getEnvironnment()

export const environmentConfig = getEnvObject();


function getEnvironnment() {
    var base_url = window.location.origin;
    if (base_url.includes('staging')) return 'staging'
    if (base_url.includes('localhost')) return 'development'
    else return 'production'
}

function getEnvObject() {
    if (environment === 'staging') return stagingConfig
    if (environment === 'development') return productionConfig
    if (environment === 'production') return productionConfig
}
